import { gql } from '@apollo/client'
import { BodyText, Button, Heading, LockIcon } from '@farol-ds/react'
import { OfferLockEventProperties } from '@jusbrasil-web/shared-apollo-client/types'
import { useEffect } from 'react'

import { useSendBoxEvent } from '../../hooks'
import { BoxMetricEventName } from '../../types'
import { useOpenModalFromPaywall } from '../context'
import { StaticOfferPaywall_PaywallDataFragment } from './__generated__/static-offer-paywall.graphql'
import { SocialProof } from './components'
import styles from './static-offer-paywall.module.scss'

interface StaticOfferPaywallProps {
  paywallData: StaticOfferPaywall_PaywallDataFragment
  lockEventProperties?: OfferLockEventProperties | null
}

export function StaticOfferPaywall({ paywallData, lockEventProperties }: StaticOfferPaywallProps) {
  const { title, subtitle, cta } = paywallData

  const openModal = useOpenModalFromPaywall()
  const { sendBoxEvent, elementRef } = useSendBoxEvent()

  useEffect(() => {
    sendBoxEvent(BoxMetricEventName.LOCK_CONTENT, lockEventProperties)
  }, [sendBoxEvent, lockEventProperties])

  return (
    <div className={styles.container} ref={elementRef}>
      <div className={styles.header}>
        <div className={styles.lockIconWrapper}>
          <LockIcon />
        </div>

        <Heading size="lg" asChild>
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
        </Heading>

        {subtitle && <BodyText size="md">{subtitle}</BodyText>}
      </div>

      <SocialProof />

      {cta && (
        <Button kind="primary" size="md" block onClick={() => openModal?.()}>
          {cta.label}
        </Button>
      )}
    </div>
  )
}

StaticOfferPaywall.fragments = {
  paywallData: gql`
    fragment StaticOfferPaywall_paywallData on PaywallData {
      title
      subtitle
      cta {
        label
      }
    }
  `,
}
